import { Component, Prop, Watch } from "vue-property-decorator";
import baseUserContexetProductComponent from "@/components/baseUserContextProductComponent";
import { productModel } from "@/models/productModel";
import Vue from "vue";

@Component({})
export default class CarouselProduct extends baseUserContexetProductComponent {
    @Prop({ default: () => [] })
    items: [];
    @Prop({ default: () => false })
    isLoadingRelations: boolean;

    currentOffset = 0;
    paginationFactor = 231;
    carouselDivSize = 0;
    resizeObserver = null;

    isDragging = false;
    startTouchX = 0;
    startTouchY = 0;
    startLeft = 0;
    startTop = 0;
    leftPosition = 0;
    topPosition = 0;

    carouselContainer = null;

    created() {}
    mounted() {
        const carouselElement = this.$refs.carouselContainer;
        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(carouselElement);

        var instance = this;
        Vue.nextTick(function () {
            setTimeout(function () {
                if (instance.$refs.carouselContainer_0) {
                    const cardElement = instance.$refs.carouselContainer_0;
                    if (cardElement) {
                        instance.carouselContainer = instance.$refs.carouselContainer_0;
                        instance.resizeObserver.observe(cardElement[0]);
                        instance.paginationFactor = cardElement[0].offsetWidth + 10;
                    }
                }
            }, 1000);
        });
    }

    // @Watch("carouselContainer")
    // onCarouselContainerChange(newVal: any) {
    //     var instance = this;
    //     const cardElement = instance.$refs.carouselContainer_0;
    //     if (cardElement) {
    //         console.log("watch 1");
    //         instance.carouselContainer = instance.$refs.carouselContainer_0;
    //         instance.resizeObserver.observe(cardElement[0]);
    //         instance.paginationFactor = cardElement[0].offsetWidth + 10;
    //     }
    // }

    // @Watch("items")
    // onItemsChange(newVal: any) {
    //     var instance = this;
    //     const cardElement = instance.$refs.carouselContainer_0;
    //     if (cardElement) {
    //         console.log("watch 2");
    //         instance.carouselContainer = instance.$refs.carouselContainer_0;
    //         instance.resizeObserver.observe(cardElement[0]);
    //         instance.paginationFactor = cardElement[0].offsetWidth + 10;
    //     }
    // }

    // @Watch("isLoadingRelations")
    // onIsLoadingRelationsChange(newVal: any) {
    //     var instance = this;
    //     const cardElement = instance.$refs.carouselContainer_0;
    //     if (cardElement) {
    //         console.log("watch 3");
    //         instance.carouselContainer = instance.$refs.carouselContainer_0;
    //         instance.resizeObserver.observe(cardElement[0]);
    //         instance.paginationFactor = cardElement[0].offsetWidth + 10;
    //     }
    // }

    handleResize(entries) {
        for (const entry of entries) {
            if (entry.target === this.$refs.carouselContainer) {
                this.carouselDivSize = entry.contentRect.width;
            }
            if (this.$refs.carouselContainer_0 && entry.target === this.$refs.carouselContainer_0) {
                this.paginationFactor = entry.contentRect.width;
            }
        }
    }

    onSelectProduct(p: productModel) {
        this.$emit("onCarouselSelectProduct", p);
    }

    get windowSize() {
        if (this.carouselDivSize) {
            var elementVisible = this.carouselDivSize / this.paginationFactor;
            return Math.floor(elementVisible);
        }

        return 0;
    }

    get atEndOfList() {
        return this.currentOffset <= this.paginationFactor * -1 * (this.items.length - this.windowSize);
    }
    get atHeadOfList() {
        return this.currentOffset >= 0;
    }

    // get pages() {
    //     if (this.windowSize > 0) return Math.floor(this.items.length / this.windowSize) + 1;
    // }

    // get pageActive() {
    //     if (this.currentOffset != 0) {
    //         return Math.floor(this.carouselDivSize / (this.currentOffset * -1)) ;
    //     }

    //     return 0;
    // }

    // moveCarousel(direction) {
    //     // Find a more elegant way to express the :style. consider using props to make it truly generic
    //     if (direction === 1 && !this.atEndOfList) {
    //         this.currentOffset -= this.paginationFactor * this.windowSize;
    //         if (this.atEndOfList) {
    //             this.currentOffset = (this.paginationFactor * -1 * (this.items.length - this.windowSize)) -50;
    //         }
    //     } else if (direction === -1 && !this.atHeadOfList) {
    //         this.currentOffset += this.paginationFactor * this.windowSize;
    //         if (this.currentOffset >= 0) {
    //             this.currentOffset = 0;
    //         }
    //     }
    // }
    moveCarousel(direction) {
        // Find a more elegant way to express the :style. consider using props to make it truly generic
        if (direction === 1 && !this.atEndOfList) {
            this.currentOffset -= this.paginationFactor * this.windowSize;
            // if (this.atEndOfList) {
            //     this.currentOffset = (this.paginationFactor * -1 * (this.items.length - this.windowSize)) -50;
            // }
        } else if (direction === -1 && !this.atHeadOfList) {
            this.currentOffset += this.paginationFactor * this.windowSize;
            if (this.currentOffset >= 0) {
                this.currentOffset = 0;
            }
        }
    }

    handleTouchStart(event) {
        this.isDragging = true;
        const touch = event.touches[0];
        this.startTouchX = touch.clientX;
        this.startLeft = this.currentOffset;
    }
    handleTouchMove(event) {
        if (this.isDragging) {
            const touch = event.touches[0];
            const deltaX = touch.clientX - this.startTouchX;
            this.leftPosition = this.startLeft + deltaX * 0.4;

            this.currentOffset = Math.floor(this.leftPosition);

            if (this.currentOffset >= 0) {
                this.currentOffset = 0;
            } else if (this.atEndOfList) {
                this.currentOffset = this.paginationFactor * -1 * (this.items.length - this.windowSize);
            }
        }
    }
    handleTouchEnd() {
        this.isDragging = false;
    }
}
